import { useNavigate } from "react-router";
import { RFNav, RFNavItem } from "../../../styles/RatesFeesStyle";
import { NavContainer, NavWrapper } from "../../../styles/CrypoAssetStyle";
import { useAuth } from "../../../hooks/useAuth";

type ActiveType = 'index' | 'buy_giftcard' | 'sell_giftcard' | 'dollar_conversion';

export const RatesNavigator = ({ active }: { active: ActiveType }) => {
   return (
      <RFNav>
         <RFNavItem to='/rates' end className={active === 'index' ? 'active' : ''}>
            Buy & sell crypto <span className="pill">API</span>
         </RFNavItem>
         <RFNavItem to='/rates/giftcard/buy' end className={active === 'buy_giftcard' ? 'active' : ''}>
            Buy giftcard <span className="pill">API</span>
         </RFNavItem>
         <RFNavItem to='/rates/giftcard/sell' className={active === 'sell_giftcard' ? 'active' : ''}>
            Sell giftcard
         </RFNavItem>
         <RFNavItem to='/rates/dollar-conversion' className={active === 'dollar_conversion' ? 'active' : ''}>
            Dollar conversion
         </RFNavItem>
      </RFNav>
   );
}


export const TabNavigator = ({ active }: { active: 'rates' | 'fees' | 'withdrawal_limits' }) => {
   const navigate = useNavigate();
   const { isSuperAdmin } = useAuth();

   return (
      <NavContainer>
         <NavWrapper children="Rates" onClick={() => active === 'rates' ? null : navigate('/rates')} $active={active === 'rates'} />
         <NavWrapper children="Fees" onClick={() => active === 'fees' ? null : navigate('/rates/fees')} $active={active === 'fees'} />
         {isSuperAdmin && (
            <NavWrapper children="Withdrawal Limits" onClick={() => active === 'withdrawal_limits' ? null : navigate('/rates/withdrawal-limits')} $active={active === 'withdrawal_limits'} />
         )}
      </NavContainer>
   )
}